
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produits",
      function () {
        return require("private-next-pages/produits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produits"])
      });
    }
  